const getters = {
  orgCode: state => state.user.orgCode,
}
export default getters



// WEBPACK FOOTER //
// ./src/SRM/store/getters.js